import { useState } from "react";
import { Link, NavLink } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页", end: true },
  { to: "/verify", label: "真假鉴定专区", end: true },
  { to: "/verify?verdict=出现反转", label: "反转追踪", end: false },
  { to: "/verify?verdict=打脸现场", label: "打脸现场", end: false },
  { to: "/about", label: "关于我们", end: true },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/80 bg-background-50/95 backdrop-blur">
      <nav className="mx-auto flex h-16 w-full items-center justify-between gap-6 px-4 md:px-8">
        <Link to="/" className="flex shrink-0 items-center gap-2" aria-label="17爆料网 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 font-label text-base font-600 tracking-tight text-background-50">
            17
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-700 tracking-wide text-foreground-950">17爆料网</span>
            <span className="font-label text-[10px] uppercase tracking-[0.22em] text-primary-700">Fact Check</span>
          </span>
        </Link>

        <div className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                  isActive
                    ? "bg-accent-100 font-500 text-accent-800"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <Link
            to="/#submit"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-500 text-background-50 transition-colors hover:bg-primary-600 sm:inline-block"
          >
            我要爆料
          </Link>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开导航菜单"
            aria-expanded={open}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-2-line text-xl"}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <div className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-3 text-sm transition-colors ${
                    isActive ? "bg-accent-100 font-500 text-accent-800" : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/#submit"
              onClick={() => setOpen(false)}
              className="mt-2 rounded-md bg-primary-500 px-3 py-3 text-center text-sm font-500 text-background-50"
            >
              我要爆料
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}